var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c(
        "div",
        { staticClass: "q-pa-sm q-body-1" },
        [
          _c("user-section-info", {
            attrs: { user: _vm.user, activeTeam: _vm.activeTeam }
          }),
          _c("user-section-popover", {
            attrs: { teams: _vm.teams, activeTeam: _vm.activeTeam }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }